export default __webpack_public_path__ + "static/media/bit2.072c045d.png";